import script from "./ChatMessageWithLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatMessageWithLinks.vue?vue&type=script&setup=true&lang=js"

import "./ChatMessageWithLinks.vue?vue&type=style&index=0&id=09b7ae8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09b7ae8c"]])

export default __exports__